import CompleteIcon from "./CompleteIcon"
import ExpiredIcon from "./ExpiredIcon"
import IncompleteIcon from "./IncompleteIcon"
import LockedIcon from "./LockedIcon"
import NotStartedIcon from "./NotStartedIcon"
import RejectedIcon from "./RejectedIcon"
import PendingApprovalIcon from "./PendingApprovalIcon"
import StartedIcon from "./StartedIcon"
import VerifiedIcon from "./VerifiedIcon"

export default {
  CompleteIcon,
  ExpiredIcon,
  IncompleteIcon,
  LockedIcon,
  NotStartedIcon,
  PendingApprovalIcon,
  RejectedIcon,
  StartedIcon,
  VerifiedIcon
}
